import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M14.828 7.031a.385.385 0 0 0-.39.39v10.157c0 .684-.538 1.172-1.172 1.172-.684 0-1.172-.488-1.172-1.172V7.422c0-1.465 1.22-2.734 2.734-2.734h2.344c1.465 0 2.734 1.269 2.734 2.734v10.156c0 .684-.537 1.172-1.172 1.172-.683 0-1.172-.488-1.172-1.172V7.422a.42.42 0 0 0-.39-.39zm14.404 14.844c.44 0 .83.39.83.83q0 .367-.293.586c-1.074.781-5.175 3.271-13.769 3.271-8.643 0-12.744-2.49-13.818-3.271a.8.8 0 0 1-.244-.586c0-.44.341-.83.78-.83zM3.5 17.188c0-4.64 2.88-8.643 7.031-10.206V9.57c-2.783 1.416-4.687 4.297-4.687 7.618v3.125H3.5zm22.656-.098c-.049-3.272-1.953-6.152-4.687-7.52V6.982C25.52 8.545 28.45 12.5 28.5 17.09v3.223h-2.344z"
    }, null, -1)
  ]))]))
}
export default { render: render }